import React from "react";

type Props = {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizes = {
  sm: "h-5 w-5 border-2",
  md: "h-8 w-8 border-3",
  lg: "h-12 w-12 border-4",
};

export const LoadingSpinner: React.FC<Props> = ({ label = "Loading...", size = "md", className = "" }) => (
  <div className={`flex justify-center py-10 ${className}`}>
    <span
      className={`animate-spin rounded-full border-gray-300 border-t-transparent ${sizes[size]}`}
      aria-hidden
    />
    <span className="ml-3 text-gray-600">{label}</span>
  </div>
);
